import config from "config";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
const LTR_DIR = "ltr";

/**
 * Get tour name and CSS selectors list and returns tour's steps
 *
 * @param {string} tourName - tour name
 * @param {Array<string>} elements - list of CSS selectors, which have to be highlighted
 *
 * @returns {Array<Object>}
 * */

const useTour = (tourName, elements) => {
  const { getTextByKey, getDirection, getPath, getHtmlByKey } = useContent();
  const isLTRDirection = getDirection() === LTR_DIR;
  const position = isLTRDirection ? "right" : "left";

  const replacePersonalPageTourTextStep1 = (constKey) => {
    if (constKey === "1_tour_page-edit_text") {
      //if text includes #PAGEURL#, replace it with the current page url after page-edit/
      const pageUrl = window.location.href.split("page-edit/")[1];
      const baseUrl = config.baseurl + getPath();
      let url = baseUrl;

      if (pageUrl.includes("?")) {
        url = baseUrl + pageUrl.split("?")[0];
        let text = getTextByKey(constKey).replaceAll("#PAGEURL#", url);
        return text;
      }
      url = baseUrl + pageUrl;
      let text = getTextByKey(constKey).replaceAll("#PAGEURL#", url);
      return text;
    } else {
      return getTextByKey(constKey);
    }
  };

  return elements.map((element, index) => ({
    element,
    title: getTextByKey(`${index + 1}_tour_${tourName}_title`),
    intro: replacePersonalPageTourTextStep1(
      `${index + 1}_tour_${tourName}_text`
    ),
    position: element === ".top-section" ? "left" : position,

    // Generate class selectors like '.tooltip_0_tour_inbox' which you can use within CSS
    tooltipClass: `tooltip_${index + 1}_tour_${tourName}${
      isLTRDirection ? "" : "_rtl tooltip_element_rtl"
    }`,
    highlightClass: `highlight_${index + 1}_tour_${tourName}${
      isLTRDirection ? "" : "_rtl"
    }`,
  }));
};

export default useTour;
